import { get, post } from '@/api/request';

const URI = "/menu"

// 菜单管理-菜单列表
export const listMenu = params => get(`${URI}/list`, params);
// 菜单管理-菜单选择
export const selectMenu = showButton => get(`${URI}/select${showButton ? '?type=true' : ''}`);
// 菜单管理-保存修改菜单
export const saveOrUpdateMenu = params => post(`${URI}/saveOrUpdate`, params);
// 菜单管理-获取菜单信息
export const getMenu = id => get(`${URI}/info/${id}`);
// 菜单管理-删除菜单
export const delMenu = id => get(`${URI}/delete/${id}`);
// 菜单管理-导航菜单列表
export const navMenu = () => get(`${URI}/nav`);



// WEBPACK FOOTER //
// ./src/api/system/menu.js